import React, { useEffect, useState } from 'react';
import { createReview, getUserInfo } from '../api/apiendpoint';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaStar } from 'react-icons/fa';

const ReviewForm = () => {
  const [name, setName] = useState('');
  const [content, setContent] = useState('');
  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userInfo = await getUserInfo();
        setName(userInfo.username);  // Set username from backend
      } catch (err) {
        setError('Failed to load user info');
      }
    };

    fetchUser();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createReview({ name, content, rating });
      setSuccess('Review submitted successfully!');
      setContent('');
      setRating(5);
      setHover(null);
      setError('');
    } catch (err) {
      setError(err.message || 'Failed to submit review');
      setSuccess('');
    }
  };

  return (
    <>
 
      <div
        className="container d-flex justify-content-center align-items-start"
        style={{ minHeight: '500px', maxWidth: '500px', marginTop: '50px' }}
      >
        <div className="w-100 border rounded shadow p-4 bg-white">
          <h4 className="mb-4 text-dark fw-bold">Leave a Review</h4>

          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Your Username</label>
              <input
                className="form-control"
                value={name}
                disabled
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Your Review</label>
              <textarea
                className="form-control"
                rows="4"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder="Your review..."
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label d-block">Rating</label>
              {[...Array(5)].map((_, index) => {
                const starValue = index + 1;
                return (
                  <label key={index} className="me-1" style={{ cursor: 'pointer' }}>
                    <FaStar
                      size={24}
                      color={starValue <= (hover || rating) ? '#ffc107' : '#e4e5e9'}
                      onClick={() => setRating(starValue)}
                      onMouseEnter={() => setHover(starValue)}
                      onMouseLeave={() => setHover(null)}
                    />
                  </label>
                );
              })}
            </div>

            <button type="submit" className="btn btns w-100">
              Submit Review
            </button>
          </form>
        </div>
      </div>

    </>
  );
};

export default ReviewForm;
